import React, {
  useContext,
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
} from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  DropdownToggle,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import { Link } from "react-router-dom";
import BootstrapTable, {
  SortOrder,
  RowSelectionType,
} from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "./Users.scss";
import { useMutation, useQuery } from "@apollo/client";
import { GET_USERS } from "./users.query";
import { ThemeContext } from "src/helpers/themeContext";
import { DELETE_USER } from "./deleteQuery";
import SweetAlert from "react-bootstrap-sweetalert";
import AddUser from "src/components/AddUser/AddUser";
import EditUser from "src/components/EditUser/EditUser";
import DeleteModal from "src/components/deleteModal/deleteModal";

// Define types for our data
interface UserData {
  Id: string;
  CreatedOn: string;
  FirstName: string;
  LastName: string;
  Email: string;
  OrgName: string;
  IsDeleted: boolean;
  IsBot: boolean;
  IsAPI: boolean;
  Auth0Id: string;
  OrganisationId: string;
  Inboxes: any[];
  role: any[];
}

const Users = () => {
  const [tableData, setTableData] = useState<UserData[]>([]);
  const [filteredData, setFilteredData] = useState<UserData[]>([]);
  const [searchText, setSearchText] = useState("");

  const [dynamic_description, setdynamic_description] = useState("");
  const [success_dlg, setsuccess_dlg] = useState(false);
  const Theme = useContext(ThemeContext);
  const [deleteUser] = useMutation(DELETE_USER);
  const [addNewModal, setAddNewModal] = useState(false);
  const [editUser, setEditUser] = useState<UserData | false>(false);
  const [deleteModal, setDeleteModal] = useState<UserData | false>(false);

  const columns = [
    {
      dataField: "Id",
      text: "Id",
      sort: true,
    },
    {
      dataField: "CreatedOn",
      text: "Created",
      sort: true,
      sortFunc: (a: string, b: string, order: string) => {
        const dateA = parseDate(a);
        const dateB = parseDate(b);
        if (order === "asc") {
          return dateA - dateB;
        }
        return dateB - dateA;
      },
    },
    {
      dataField: "FirstName",
      text: "First Name",
      sort: true,
    },
    {
      dataField: "LastName",
      text: "Last Name",
      sort: true,
    },
    {
      dataField: "Email",
      text: "Login",
      sort: true,
    },
    {
      dataField: "OrgName",
      text: "Org Name",
      sort: true,
    },
    {
      dataField: "IsDeleted",
      text: "IsDeleted",
      sort: true,
    },
    {
      dataField: "IsBot",
      text: "IsBot",
      sort: true,
    },
    {
      dataField: "IsAPI",
      text: "IsAPI",
      sort: true,
    },
    {
      dataField: "Auth0Id",
      text: "Auth Id",
      sort: true,
    },
    {
      dataField: "Actions",
      text: "Actions",
      formatter: (cell: any, row: UserData) => {
        return (
          <UncontrolledDropdown>
            <DropdownToggle tag="button" className="btn btn-light btn-sm">
              <i className="uil uil-ellipsis-h"></i>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-end">
              {!row.IsDeleted && (
                <DropdownItem onClick={() => setDeleteModal(row)}>
                  <i className="mdi mdi-delete font-size-16 me-1"></i>
                  Delete User
                </DropdownItem>
              )}
              <DropdownItem
                onClick={() => {
                  setEditUser(row);
                }}
              >
                <i className="mdi mdi-pencil font-size-16 text-success me-1"></i>
                Edit
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        );
      },
    },
  ];

  const defaultSorted: [{ dataField: string; order: SortOrder }] = [
    {
      dataField: "Created",
      order: "desc" as SortOrder,
    },
  ];

  // Removed row selection checkbox column

  const parseDate = (dateStr: string): number => {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day).getTime(); // month is 0-based
  };

  const handleDelete = async (user: UserData) => {
    setDeleteModal(false);
    await deleteUser({
      variables: {
        id: user.Id,
      },
    });
    setsuccess_dlg(true);
    setdynamic_description(
      "Item will not be available to the user now, it will be permanently deleted in 60 days"
    );
    refetch();
  };

  const { data, refetch } = useQuery(GET_USERS, { fetchPolicy: "no-cache" });

  useEffect(() => {
    if (data && data.msgbox_User) {
      var tmpData = data.msgbox_User
        .filter((item: any) => item.userorganisation)
        .map(function (item: {
          UserId: any;
          CreatedAt: string | number | Date;
          FirstName: any;
          LastName: any;
          IsDeleted: any;
          IsBot: any;
          EMail: any;
          Auth0Id: any;
          IsAPI: any;
          userorganisation: { Name: string };
          OrganisationId: any;
          UserInboxes: any;
          UserRoles: any;
        }) {
          return {
            Id: item.UserId,
            CreatedOn: new Date(item.CreatedAt).toLocaleDateString(),
            FirstName: item.FirstName,
            LastName: item.LastName,
            IsDeleted: item.IsDeleted,
            OrgName: item?.userorganisation?.Name || "",
            IsBot: item.IsBot,
            IsAPI: item.IsAPI,
            Auth0Id: item.Auth0Id,
            Email: item.EMail,
            OrganisationId: item.OrganisationId,
            Inboxes: item.UserInboxes,
            role: item.UserRoles,
          };
        });
      setTableData(tmpData);
      setFilteredData(tmpData);
    }
  }, [data]);

  const refetchData = () => {
    refetch();
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchText(searchValue);

    const filtered = tableData.filter((item: UserData) => {
      return (
        item.FirstName?.toLowerCase().includes(searchValue) ||
        item.LastName?.toLowerCase().includes(searchValue) ||
        item.Email?.toLowerCase().includes(searchValue) ||
        item.OrgName?.toLowerCase().includes(searchValue)
      );
    });
    setFilteredData(filtered);
  };

  const handleSetEditModal: Dispatch<SetStateAction<boolean>> = value => {
    if (typeof value === "function") {
      const newValue = value(editUser !== false);
      if (!newValue) {
        setEditUser(false);
      }
    } else if (!value) {
      setEditUser(false);
    }
  };

  const pageOptions = {
    sizePerPage: 10,
    totalSize: tableData.length,
    custom: true,
    sizePerPageList: [
      { text: "10", value: 10 },
      { text: "25", value: 25 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
    ],
    showSizePerPage: true,
  };

  return (
    <React.Fragment>
      {success_dlg ? (
        <SweetAlert
          success
          title={Theme.name}
          onConfirm={() => {
            setsuccess_dlg(false);
          }}
        >
          {dynamic_description}
        </SweetAlert>
      ) : null}
      <DeleteModal
        isOpen={deleteModal !== false}
        cancel={() => setDeleteModal(false)}
        submit={() => handleDelete(deleteModal as UserData)}
      />
      <Card>
        <CardHeader>
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <h4 className="card-title">All Users</h4>
              </div>
            </Col>
            <Col md={6}>
              <div className="d-flex flex-wrap align-items-start justify-content-md-end mt-2 mt-md-0 gap-2 mb-3">
                <div className="search-box ms-2">
                  {/* <div className="position-relative">
                    <Input
                      type="text"
                      className="form-control bg-light border-light rounded"
                      placeholder="Search..."
                      onChange={handleSearch}
                      value={searchText}
                    />
                    <i className="uil uil-search search-icon"></i>
                  </div> */}
                </div>
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => setAddNewModal(true)}
                >
                  <i className="uil uil-plus me-1"></i> Add New
                </button>

                <div>
                  <Link to="#" className="btn btn-light" onClick={refetchData}>
                    <i className="uil uil-refresh me-1"></i> Refresh
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardHeader>
        <CardBody>
          <PaginationProvider pagination={paginationFactory(pageOptions)}>
            {({ paginationProps, paginationTableProps }) => (
              <React.Fragment>
                <Row className="mb-2">
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="position-relative">
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        <i className="bx bx-search-alt search-icon" />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col xl="12">
                    <div className="table-responsive">
                      <BootstrapTable
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes="table align-middle table-nowrap"
                        headerWrapperClasses="thead-dark"
                        headerClasses="table-dark"
                        {...paginationTableProps}
                        keyField="Id"
                        columns={columns}
                        data={filteredData}
                      />
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-md-center mt-30">
                  <Col className="inner-custom-pagination d-flex">
                    <div className="d-inline">
                      <SizePerPageDropdownStandalone {...paginationProps} />
                    </div>
                    <div className="text-md-right ms-auto">
                      <PaginationListStandalone {...paginationProps} />
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            )}
          </PaginationProvider>
        </CardBody>
      </Card>
      <AddUser
        modal={addNewModal}
        setModal={setAddNewModal}
        onRefetch={refetchData}
      />
      <EditUser
        modal={editUser !== false}
        setModal={handleSetEditModal}
        data={editUser as UserData}
        onRefetch={refetchData}
      />
    </React.Fragment>
  );
};

export default Users;
